import React, { useEffect } from "react";
import styled from "styled-components";
import Navbar from "../component/Header.js/Navbar/Navbar";
import Footer from "../component/Footer/Footer";
import { Link } from "react-router-dom";

const ShippingDetails = () => {
    const MainBox = styled.div`
    height: fit-content;
    padding: 4rem 4rem;
    width: 90%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 2rem;
    position: relative;
    @media only screen and (max-width: 1220px) {
      width: 100%;
      padding: 1rem;
    }
  `;

    return (
        <>
            <Navbar />
            <MainBox>
                <h1>Shipping & Delivery Policy | Samriddhi India</h1>

                <p>At Samriddhi India, we are committed to delivering your favorite clothing quickly and securely. As a leading online clothing store in India, we make every effort to ship and deliver our products on time, so you can enjoy your new ethnic clothing without delay.</p>

                <p>By shopping on our website <a href="https://www.samriddhiindia.in">www.samriddhiindia.in</a>, you agree to the terms mentioned in this Shipping & Delivery Policy.</p>

                <h2>Order Processing & Dispatch</h2>
                <ul>
                    <li>All clothing orders are processed within 48 hours of being placed.</li>
                    <li>Products are shipped from our warehouse in Dehradun, India, to the shipping address provided by the customer.</li>
                    <li>We partner with trusted courier services such as Delhivery, Blue Dart, FedEx, DTDC, DHL to ensure safe and timely delivery.</li>
                    <li>The estimated delivery date is shared with you in the order confirmation email/SMS.</li>
                </ul>

                <h2>Delivery Timeline & Address Guidelines</h2>
                <ul>
                    <li>Orders are processed Monday to Saturday, excluding public holidays.</li>
                    <li>We deliver to most pin codes across India. Please provide a complete street address and pin code at checkout.</li>
                    <li>We currently do not deliver to Post Office Box addresses.</li>
                </ul>

                <h3>Multiple Products in One Order</h3>
                <p>We will try to ship all your clothing items together, but in some cases, separate shipments may be required.</p>

                <h3>Address Change</h3>
                <p>If you wish to change your shipping address, you can request it within 6 hours of placing the order or before the order is shipped (whichever is earlier). Contact us at <a href="mailto:care@samriddhiindia.in">care@samriddhiindia.in</a> for assistance.</p>

                <h2>Delivery Attempts</h2>
                <p>Our courier partners will make three (3) delivery attempts to your address. If the order remains undelivered after three attempts, it will be marked as undeliverable, and our team will contact you for re-dispatch options.</p>

                <h2>Out-of-Stock or Delayed Orders</h2>
                <p>We aim to keep all clothing products listed on our website in stock. However, in the rare case a product is unavailable or delayed, we will inform you within 2 working days on your registered mobile number or email address.</p>

                <h2>Order Tracking Facility</h2>
                <p>Once your order is shipped, you will receive an SMS and email with the tracking number.</p>

                <p>You can easily track your clothing order online by visiting the “Track Order” section under My Account on <a href="https://www.samriddhiindia.in">www.samriddhiindia.in</a>.</p>

                <p>For direct courier tracking, you may also visit:</p>
                <ul>
                    <li><a href="https://www.bluedart.com/" target="_blank">Blue Dart Express</a></li>
                    <li><a href="https://www.delhivery.com/" target="_blank">Delhivery</a></li>
                    <li><a href="https://www.fedex.com" target="_blank">FedEx</a></li>
                    <li><a href="https://www.indiapost.gov.in" target="_blank">India Post</a></li>
                </ul>

                <h2>Customer Support</h2>
                <p>For any delivery-related queries or disputes, email us at <a href="mailto:care@samriddhiindia.in">care@samriddhiindia.in</a> with your order details or call us at <a href="tel:+919520782777">+91 95207 82777</a>. Our team is here to ensure your clothing shopping experience is smooth and worry-free.</p>
            </MainBox>
            <Footer />
        </>
    );
};

export default ShippingDetails;
